import { ErrorBoundary } from 'react-error-boundary';
import ErrorFallback from '../ErrorFallback';
import { JourneyLoaderProps } from './JourneyLoader.types';
import ModuleLoader from '../ModuleLoader';
import Loading from '../Loading';
import { memo } from 'react';

function JourneyLoader({ journey, innerProps, loadingTitle }: JourneyLoaderProps) {
    const initialArgs = journey.config ? { ...journey.config } : {};

    const application = {
        id: journey.id,
        instance_id: `${journey.id}_${crypto.randomUUID()}`,
        src: journey.journeyUrl,
        module: './Component',
        scope: journey.scope,
        remotes: journey.remotes || {},
        ...(Object.keys(initialArgs).length > 0 && { initialArgs })
    };

    const finalInnerProps = {
        ...innerProps,
        application
    };

    return (
        <ErrorBoundary FallbackComponent={ErrorFallback}>
            <ModuleLoader
                url={application.src}
                scope={application.scope}
                module={application.module}
                loadingComponent={<Loading title={loadingTitle || 'A carregar...'} />}
                key={application.instance_id}
                innerProps={finalInnerProps}
            />
        </ErrorBoundary>
    );
}

export default memo(JourneyLoader);
